import React, { useEffect, useState } from "react";
import { Operacao } from "../../../Models/Cadastros/Operacao/Operacao";
import DropDownListComponent from "../../../Components/Forms/DropDownListComponent";
import TextFieldComponent from "../../../Components/Forms/TextFieldComponent";
import DropDownBooleanComponent from "../../../Components/Forms/DropDownBooleanComponent";
import InlineSearchComponent from "../../../Components/Forms/InlineSearchComponent";

const OperacaoServicoTab = (props: any) => {
    const [operacao, setOperacao] = useState<any>(new Operacao());
    const [perfis, setPerfis] = useState<any[]>([]);

    useEffect(() => {
        setPerfis(props.perfis);
    }, [props.perfis]);

    useEffect(() => {
        setOperacao(props.operacao);
    }, [props.operacao]);

    const optionHabilitaChecklistIntegrado = [
        { label: 'NÃO', value: 0 },
        { label: 'OPCIONAL', value: 1 },
        { label: 'OBRIGATÓRIO', value: 2 },
    ]
    
    return (
        <div className="row">
            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Cálculo Rota'
                    model={operacao}
                    modelField='calculo_rota' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Desvio de Rota'
                    model={operacao}
                    modelField='calculo_desvio_rota' />
            </div>
            
            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Calcular apenas rota associada'
                    model={operacao}
                    modelField='calcular_apenas_com_rota_associada' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Calcular apenas rota associada'
                    model={operacao}
                    modelField='calcular_apenas_com_rota_associada' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Início por status/previsão'
                    model={operacao}
                    modelField='inicio_automatico_por_status_data_prevista' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Início por localização'
                    model={operacao}
                    modelField='inicio_por_localizacao' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Fim por localização'
                    model={operacao}
                    modelField='fim_por_localizacao' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Verificar início por macro'
                    model={operacao}
                    modelField='verificar_inicio_por_macro' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Verificar fim por macro'
                    model={operacao}
                    modelField='verificar_fim_por_macro' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Fim por Ag.Fim'
                    model={operacao}
                    modelField='fim_automatico_por_status_tempo' />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label='Tempo fim Ag.Fim'
                    field='tempo_fim_viagem_automatico'
                    model={operacao} />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Fim por previsão'
                    model={operacao}
                    modelField='fim_por_data_prevista' />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Tempo fim previsão"
                    field='tempo_fim_por_data_prevista'
                    model={operacao} />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Destino interm. por localização'
                    model={operacao}
                    modelField='destino_intermediario_por_localizacao' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Verificar dest. interm. por macro'
                    model={operacao}
                    modelField='verificar_destino_intermediario_macro' />
            </div>
            

            <div className="col-md-3 mb-3">
                <DropDownListComponent
                    label='Integração Automatica Check List'
                    options={optionHabilitaChecklistIntegrado}
                    valueField='value'
                    textField='label'
                    model={operacao}
                    modelField='integracao_automatica_checklist' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Evento rota apenas em viagem'
                    model={operacao}
                    modelField='gera_eventos_rota_apenas_em_viagem' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Anotação automática'
                    model={operacao}
                    modelField='anotacao_automatica' />
            </div>

            <div className="col-md-6 mb-3">
                <InlineSearchComponent
                    id='combo_grupo_parada_nao_autorizada'
                    label='Grupo parada não autorizada'
                    urlApi='buscaGrupoParadas'
                    valueField='id'
                    textField='grupo_parada'
                    model={operacao}
                    modelField='ponto_parada_nao_autorizada_grupo_id' />
            </div>

            <div className="col-md-6 mb-3">
                <InlineSearchComponent
                    id='combo_grupo_parada_autorizada'
                    label='Grupo parada autorizada'
                    urlApi='buscaGrupoParadas'
                    valueField='id'
                    textField='grupo_parada'
                    model={operacao}
                    modelField='ponto_parada_autorizada_grupo_id' />
            </div>

            <div className="col-md-6 mb-3">
                <InlineSearchComponent
                    id='combo_grupo_area_risco'
                    label='Grupo área de risco'
                    urlApi='buscaGrupoAreaRisco'
                    valueField='id'
                    textField='grupo_area_risco'
                    model={operacao}
                    modelField='area_risco_grupo_id' />
            </div>

            <div className="col-md-6 mb-3">
                <InlineSearchComponent
                    id='combo_sipat'
                    label='Sipat'
                    urlApi='buscaSipat'
                    valueField='id'
                    textField='sipat'
                    model={operacao}
                    modelField='sipat_configuracao_id' />
            </div>

            <div className="col-md-6 mb-3">
                <InlineSearchComponent
                    id='combo_controle_ignicao'
                    label='Controle Ignição'
                    urlApi='buscaControleIgnicao'
                    valueField='id'
                    textField='controle_ignicao'
                    model={operacao}
                    modelField='controle_ignicao_id' />
            </div>
        </div>
    );
}

export default OperacaoServicoTab;